<template>

    <SubHeader title="Fiche Institutions" :breads="[{ name: 'Créer Institution' }, { name: 'Fiche Institution' }]"
        :action="{}" />
    <div class="row">
        <div class="col-md-12">
            <form @submit.prevent="handleSubmit(this.data)">


                <div class="row">
                    <div class="col-md-6">
                        <div class="card">

                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Libellé</label>
                                    <input type="text" v-model="data.label" id="label" class="form-control"
                                        placeholder="Institution" value="">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="email">Email</label>
                                    <input type="text" v-model="data.email" id="email" class="form-control"
                                        placeholder="Email" value="">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="contact">Contact</label>
                                    <input type="text" v-model="data.phone" id="contact" class="form-control"
                                        placeholder="contact" value="">
                                </div>
                                <div class="mb-3 ">
                                    <label class="form-label" for="type">Type</label>
                                    <m-select v-model="data.type" :loading="institutionTypeIsLoading"  :required="true" :options="institutionTypeItems" :searchable="false" 
                                        placeholder="Type d'institution" track-by="id" label="label" >
                                    </m-select>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Enregistrer</button>&nbsp;
                                <button type="button" class="btn btn-danger" @click="this.$router.back()">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "AdminConfigCreateInstitution",
    components: {
        SubHeader
    },
    data() {
        return {
            data: {},
        }
    },

    computed: {
        ...mapFields("institution/create", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            items: "items",
            isCreated:"isCreated"

        }),
        ...mapFields("institution_type/list", {
            institutionTypeIsLoading: "isLoading",
            institutionTypeIsSuccess: "isSuccess",
            institutionTypeShowMessage: "showMessage",
            institutionTypeMessage: "message",
            institutionTypeItems: "items"

        })
    },

    methods: {
        ...mapActions({
            handleSubmit: "institution/create/create",
            reset: "institution/create/resetData",
            getInstitutionTypes: "institution_type/list/getAll",
            
        })
    },
    watch:{
        "data.type"(val){
            if(val){
                this.data.institutiontype_id = val.id ?? null
            }
        },
        isCreated(val){
            if(val){
                this.$router.push({name:'AdminConfigInstitution'})
            }
        }
    },

    unmounted() {
        this.reset()
    },
    mounted() {
        this.getInstitutionTypes()
    }
}
</script>
